"use client";

import BFLLink from "@repo/shared-ui/BFLLink";
import { handleHeaderPrimeClickDL } from "./HeaderAnalyticsFunction";

interface HeaderPrimeProps {
  headerPrime?: {
    ctaText?: string;
    ctaLink?: string;
  };
}

const Prime: React.FC<HeaderPrimeProps> = ({ headerPrime }) => {
  const destinationUrl = headerPrime?.ctaLink || "";
  const ctaText = headerPrime?.ctaText || "Prime";

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    // Track analytics before navigation
    handleHeaderPrimeClickDL(ctaText, destinationUrl);

    // Navigate after analytics completes
    window.location.href = destinationUrl;
  };

  return (
    <BFLLink
      href={destinationUrl}
      aria-label={ctaText}
      onClick={handleClick}
      className="relative order-4 mx-0 my-0 flex flex-col items-center px-2 pt-5 pb-[30px] hover:bg-[#001326] md:order-5 md:min-h-[37px]"
    >
      <i className="icomoon text-xl before:content-['\e93c']"></i>
      <span className="absolute top-[20px] right-[0px] h-[8px] w-[8px] rounded-full bg-[#E8B100]"></span>
      <span className="hidden text-xs leading-[14px] md:!block">{ctaText}</span>
    </BFLLink>
  );
};
export default Prime;
